/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarnings
 */
export interface CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'detectedDpi'?: CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'calculatedDpi'?: CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'colorGradation'?: CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'heightMillis'?: CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'widthMillis'?: CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum;
}

export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum];


